import { GetterTree } from 'vuex';
import { ReportsState, ReportsGetter } from './types';

export const getters: GetterTree<ReportsState, any> = {
  [ReportsGetter.GetReportsStatus]: (state) => state.reportsStatus,
  
  [ReportsGetter.GetAllReports]: (state) => state.reportsStatus?.reports || [],
    
  [ReportsGetter.GetEnabledConfigs]: (state) => state.reportsStatus?.configs || [],
    
  [ReportsGetter.GetScheduledConfigs]: (state) => state.reportsStatus?.configs.filter((config) => config.type === 'scheduled') || [],
    
  [ReportsGetter.GetSingleConfigs]: (state) => state.reportsStatus?.configs.filter((config) => config.type === 'single') || []
};
